module.exports = __webpack_public_path__ + "img/work.c3081e03.svg";